module.exports = __webpack_public_path__ + "static/media/17-7.799074cd.mp3";